import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
// @ts-ignore
import { makeSelectPersonValue } from 'services/people/selectors';

// Global Components
// @ts-ignore
import RoleName from 'components/RoleName';

import { AppState } from 'services/types';

interface IOwnProps {
    personId: number;
}

interface IStateProps {
    roleIds?: number[];
}

interface IDispatchProps {}

export interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

export class PersonRoles extends React.PureComponent<IProps> {
    render() {
        const { roleIds } = this.props;
        if (!roleIds || !roleIds.length) return null;
        return roleIds.map((roleId, index) => (
            <React.Fragment key={roleId}>
                {index ? ', ' : ''}
                <RoleName roleId={roleId} />
            </React.Fragment>
        ));
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    IOwnProps,
    IStateProps
>({
    roleIds: makeSelectPersonValue('roleIds')
});

export default connect(mapStateToProps)(PersonRoles);
